"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoCard = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var can_1 = tslib_1.__importDefault(require("can"));
require("components/card/photo/photo");
require("components/timeline/animation-item/animation-item");
var React = tslib_1.__importStar(require("react"));
var ReactCanWrapper_1 = require("../../../../ReactCanWrapper");
function PhotoCard(props) {
    var options = new can_1.default.Map(props.options);
    var template = "<animation-item\n                        {timeline-type}=\"gs-timeline\"\n                        {is-embed}=\"false\"\n                        ><card-photo timeline-type=\"gs-timeline\" card-index=\"{{cardIndex}}\" fromtimeline=\"true\">\n                        </card-photo></animation-item>";
    return (React.createElement(ReactCanWrapper_1.ReactCanWrapper, { className: 'm-gs-timeline__card', options: options, template: template }));
}
exports.PhotoCard = PhotoCard;
